import { render, staticRenderFns } from "./template-text.vue?vue&type=template&id=615775f2&scoped=true&"
import script from "./template-text.vue?vue&type=script&lang=js&"
export * from "./template-text.vue?vue&type=script&lang=js&"
import style0 from "./template-text.vue?vue&type=style&index=0&id=615775f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615775f2",
  null
  
)

export default component.exports